export default {
    state: {
        author: false
    },
    getters: {
        author: state => {
            return state.author
        }
    },
    mutations: {
        SET_READER (state) {
            state.author = false
        },
        SET_AUTHOR (state) {
            state.author = true
        }
    },
    actions: {
        SET_READER (context) {
            context.commit('SET_READER')
        },
        SET_AUTHOR (context) {
            context.commit('SET_AUTHOR')
        }
    }
}